<template>
    <section class="sports-section">
        <div class="section-header">
            <p class="section-kicker">Club Activities</p>
            <h2 class="section-title">Sports Section</h2>
            <p class="section-copy">
                Discover our diverse range of sports and activities for all skill levels.
            </p>
        </div>

        <div class="cards">
            <SportsCard
                v-for="(card, index) in dataList"
                :key="index"
                :title="card.name"
                :content="card.description.length > 400 ? card.description.substring(0, 400) + '...' : card.description"
                :image="card.image"
                @click="openDetails(card)"
            />
        </div>
    </section>
</template>

<script setup>
import { ref, onBeforeMount } from "vue";
import SportsCard from "./CommonCard/SportsCard.vue";
import axios from "axios";
import { useRouter } from "vue-router";

const router = useRouter();
const dataList = ref([]);

onBeforeMount(async () => {
  await listSportSection();
});

const listSportSection = async () => {
  try {
    const response = await axios.get('/sport_section_lists.php');
    dataList.value = response.data.data || [];
  } catch (error) {
    console.error(error.message);
  }
};

const openDetails = (card) => {
  router.push({
    name: "SportSectionDetail",
    params: {
      title: card.name
    }
  });
};
</script>

<style scoped lang="scss">
.sports-section {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
}

.section-header {
    margin-bottom: 24px;
}

.section-kicker {
    margin: 0 0 8px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.section-title {
    margin: 0;
    font-size: clamp(30px, 3vw, 44px);
    line-height: 1.08;
    font-weight: 700;
    color: #0f172a;
}

.section-copy {
    margin: 10px 0 0;
    max-width: 760px;
    color: #64748b;
    font-size: 16px;
    line-height: 1.7;
}

.cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 22px;
    align-items: stretch;
}

@media (max-width: 992px) {
    .cards {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .sports-section {
        padding: 0 16px;
    }

    .section-header {
        margin-bottom: 18px;
    }

    .cards {
        grid-template-columns: 1fr;
        gap: 16px;
    }
}
</style>
